<script setup lang="ts">
import type { RouteLocationRaw } from "vue-router";
import { tileActionClass } from "@carnet/ui/utils/tile";

withDefaults(
  defineProps<{
    to: RouteLocationRaw;
    icon?: string;
    external?: boolean;
  }>(),
  { icon: "icon:external", external: false }
);
</script>

<template>
  <NuxtLink :to :target="external ? '_blank' : undefined" :rel="external ? 'noopener noreferrer' : undefined" :class="tileActionClass">
    <UIcon :name="icon" class="size-4" aria-hidden="true" />
  </NuxtLink>
</template>
